import React, { useState, memo } from "react";
import { Handle, Position } from "reactflow";

import CustomNode from "./CustomNode";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

import { getAbsoluteBalanceString } from "../../../util/stringUtils";
import { capitalizeFirstLetters } from "../../../util/stringUtils";

import { transactions } from "../../../data/transactions";

import "./Account.scss";

const Account = ({ data }) => {
  const [expanded, setExpanded] = useState(false);
  const handleClick = (e) => {
    setExpanded(!expanded);
  };

  const balance = getAbsoluteBalanceString(
    data.balances.current,
    data.balances.iso_currency_code
  );
  const availableBalance = getAbsoluteBalanceString(
    data.balances.available,
    data.balances.iso_currency_code
  );
  const limit = getAbsoluteBalanceString(
    data.balances.limit,
    data.balances.iso_currency_code
  );
  const accountType = capitalizeFirstLetters(data.type);
  const accountSubtype = capitalizeFirstLetters(data.subtype);

  return (
    <CustomNode color="#fff">
      <Handle type="target" position={Position.Top} isConnectable={false} />
      <Handle type="source" position={Position.Bottom} isConnectable={false} />

      <div className={`accountNode ${expanded && "expanded"}`}>
        <p className="name">{data.name}</p>
        <div className="attrContainer balanceContainer">
          <span className="attrLabel balanceContainer">Balance:</span>
          <span className="attrValue balanceValue">{balance}</span>
        </div>
        <hr className="spacer" />
        <div className="attrContainer accountTypeContainer">
          <span className="attrLabel accountTypeLabel">Account Type:</span>
          <span className="attrValue accountTypeValue">{accountType}</span>
        </div>
        {expanded || (
          <div className="attrContainer availableBalanceContainer">
            <span className="attrLabel availableBalanceLabel">
              Available Balance:
            </span>
            <span className="attrValue availableBalanceValue">
              {availableBalance}
            </span>
          </div>
        )}
        <div className={`extraInfo ${expanded && "expanded"}`}>
          <div className="attrContainer accountTypeContainer">
            <span className="attrLabel accountTypeLabel">Account Subtype:</span>
            <span className="attrValue accountTypeValue">{accountSubtype}</span>
          </div>
          <div className="attrContainer officialNameContainer">
            <span className="attrLabel officialNameLabel">Account Name: </span>
            <span
              className="attrValue officialNameValue"
              title={data.official_name ? data.official_name : data.name}
            >
              {data.official_name ? data.official_name : data.name}
            </span>
          </div>
          <div className="attrContainer maskContainer">
            <span className="attrLabel maskLabel">Account Number: </span>
            <span className="attrValue maskValue">
              <span>******</span>
              {data.mask}
            </span>
          </div>
          <div className="attrContainer availableBalanceContainer">
            <span className="attrLabel availableBalanceLabel">
              Account Currency:
            </span>
            <span className="attrValue availableBalanceValue">
              {data.balances.iso_currency_code}
            </span>
          </div>
          <hr className="spacer" />
          <div className="attrContainer availableBalanceContainer">
            <span className="attrLabel availableBalanceLabel">
              Available Balance:
            </span>
            <span className="attrValue availableBalanceValue">
              {availableBalance}
            </span>
          </div>
          <div className="attrContainer availableBalanceContainer">
            <span className="attrLabel availableBalanceLabel">
              Authorized Limit:
            </span>
            <span className="attrValue availableBalanceValue">{limit}</span>
          </div>
          <hr className="spacer" />
          <div className="attrContainer balanceContainer">
            <span className="attrLabel balanceContainer">Transactions</span>
          </div>
          {transactions.latest_transactions
            .filter((txn) => txn.account_id === data.account_id)
            .map((txn) => (
              <div className="attrContainer availableBalanceContainer">
                <span className="attrLabel availableBalanceLabel">
                  {txn.name}
                </span>
                <span className="attrValue availableBalanceValue">
                  {getAbsoluteBalanceString(txn.amount, txn.iso_currency_code)}
                </span>
              </div>
            ))}
        </div>
        <div className="arrow-container" onClick={handleClick}>
          <FontAwesomeIcon
            className="arrow"
            icon={expanded ? faChevronUp : faChevronDown}
          />
        </div>
      </div>
    </CustomNode>
  );
};

export default memo(Account);
